import {
  MANAGE_OWNER_MANAGER_REQUEST,
  MANAGE_OWNER_MANAGER_SUCCESS,
  MANAGE_OWNER_MANAGER_FALIURE,
  GET_OWNER_MANAGER_REQUEST,
  GET_OWNER_MANAGER_SUCCESS,
  GET_OWNER_MANAGER_FALIURE,
  UPDATE_PHONE_NUMBERS_REQUEST,
  UPDATE_PHONE_NUMBERS_SUCCESS,
  UPDATE_PHONE_NUMBERS_FALIURE,
  GET_PHONE_NUMBERS_REQUEST,
  GET_PHONE_NUMBERS_SUCCESS,
  GET_PHONE_NUMBERS_FALIURE,
  RESET_ACCOUNT
} from './AccountSettingsConstants'
import {config} from '../config'

export const resetAccount = (change_password_req) =>{
  return{
    type : RESET_ACCOUNT,
    payload : change_password_req
  }
}

export const manageOwnerRequest = (change_password_req) =>{
  return{
    type : MANAGE_OWNER_MANAGER_REQUEST,
    payload : change_password_req
  }
}

export const manageOwnerSuccess = (change_password_success) =>{
  return{
    type : MANAGE_OWNER_MANAGER_SUCCESS,
    payload : change_password_success
  }
}

export const manageOwnerFaliure = (error) =>{
  return{
    type : MANAGE_OWNER_MANAGER_FALIURE,
    payload : error
  }
}

export const getManageOwnerRequest = (change_password_req) =>{
  return{
    type : GET_OWNER_MANAGER_REQUEST,
    payload : change_password_req
  }
}

export const getManageOwnerSuccess = (change_password_success) =>{
  return{
    type : GET_OWNER_MANAGER_SUCCESS,
    payload : change_password_success
  }
}

export const getManageOwnerFaliure = (error) =>{
  return{
    type : GET_OWNER_MANAGER_FALIURE,
    payload : error
  }
}


export const phoneNumbersRequest = (change_password_req) =>{
  return{
    type : UPDATE_PHONE_NUMBERS_REQUEST,
    payload : change_password_req
  }
}

export const phoneNumbersSuccess = (change_password_success) =>{
  return{
    type : UPDATE_PHONE_NUMBERS_SUCCESS,
    payload : change_password_success
  }
}

export const phoneNumbersFaliure = (error) =>{
  return{
    type : UPDATE_PHONE_NUMBERS_FALIURE,
    payload : error
  }
}

export const getPhoneNumbersRequest = (change_password_req) =>{
  return{
    type : GET_PHONE_NUMBERS_REQUEST,
    payload : change_password_req
  }
}

export const getPhoneNumbersSuccess = (change_password_success) =>{
  return{
    type : GET_PHONE_NUMBERS_SUCCESS,
    payload : change_password_success
  }
}

export const getPhoneNumbersFaliure = (error) =>{
  return{
    type : GET_PHONE_NUMBERS_FALIURE,
    payload : error
  }
}

export const resetAccountCall = () =>{
  return(dispatch) => {
    dispatch(resetAccount(""));
  }
}  


export const updateOwnerManager = (managerName, ownerName) =>{
  return(dispatch) => {
    dispatch(manageOwnerRequest(managerName))
    const url =`${config.api_root}/api/v1/merchants/manager_and_owner_name`
    const request_option = {
       method: "POST",
       headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ config.token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "fields": {
            "manager_name": managerName,
            "owner_name":ownerName
          },
          "form_id": "",
          "user_id": config.user_id
        })
      }
    
    fetch(url, request_option)
     .then(response => response.json() )
     .then(res =>{
        const res_success = res;
        if(res_success.request_status) {
          dispatch(manageOwnerSuccess(res_success));
          dispatch(getOwnerManager());
        } else dispatch(manageOwnerFaliure(res_success));
     })
    .catch(error => {
      const errorMsg = error
      dispatch(manageOwnerFaliure(errorMsg))
    })
  }
}

export const getOwnerManager = () =>{
  return(dispatch) => {
    dispatch(getManageOwnerRequest(true))
    const url =`${config.api_root}/api/v1/merchants/manager_and_owner_name`
    const request_option = {
       method: "GET",
       headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ config.token,
            'Content-Type': 'application/json'
        }
      }
    
    fetch(url, request_option)
     .then(response => response.json() )
     .then(res =>{
        dispatch(getManageOwnerSuccess(res))
     })
    .catch(error => {
      const errorMsg = error
      dispatch(getManageOwnerFaliure(errorMsg))
    })
  }
}

export const updatePhoneNumbers = (smsPhone, faxNumber, merchantContact) =>{
  return(dispatch) => {
    dispatch(phoneNumbersRequest(smsPhone))
    const url =`${config.api_root}/api/v1/merchants/phone_numbers`
    const request_option = {
       method: "POST",
       headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ config.token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "fields": {
            "sms_phone": smsPhone,
            "fax_number": faxNumber,
            "merchant_contact": merchantContact
          },
          "form_id": "",
          "user_id": config.user_id
        })
      }
    
    fetch(url, request_option)
     .then(response => response.json() )
     .then(res =>{
        const res_success = res;
        if(res_success.request_status) {
          dispatch(phoneNumbersSuccess(res_success));
          dispatch(getPhoneNumbers())
        }
        else dispatch(phoneNumbersFaliure(res_success));        
     })
    .catch(error => {
      const errorMsg = error
      dispatch(phoneNumbersFaliure(errorMsg))
    })
  }
}

export const getPhoneNumbers = () =>{
  return(dispatch) => {
    dispatch(getPhoneNumbersRequest(true))
    const url =`${config.api_root}/api/v1/merchants/phone_numbers`
    const request_option = {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ config.token,
            'Content-Type': 'application/json'
        }
    }
    
    fetch(url, request_option)
     .then(response => response.json() )
     .then(res =>{
        dispatch(getPhoneNumbersSuccess(res))
     })
    .catch(error => {
      const errorMsg = error
      dispatch(getPhoneNumbersFaliure(errorMsg))
    })
  }
}